
import { ListingsGrid } from "./ListingsGrid";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Database } from "@/integrations/supabase/types";
import { motion } from "framer-motion";

type ListingRow = Database["public"]["Tables"]["listings"]["Row"];
interface Listing extends Omit<ListingRow, 'images'> {
  images: string[];
}

interface ListingsSectionProps {
  listings: Listing[];
  onListingClick?: (listingId: string) => void;
  isPublic?: boolean;
}

export const ListingsSection = ({ listings, onListingClick, isPublic }: ListingsSectionProps) => {
  if (!listings || listings.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="p-4 sm:p-6 md:p-8"
    >
      <motion.h2 
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5, delay: 0.3 }}
        className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6 text-gray-800"
      >
        Listings
      </motion.h2>
      <ScrollArea className="h-full w-full rounded-lg">
        <ListingsGrid 
          listings={listings}
          onListingClick={(id) => onListingClick?.(id)}
        />
      </ScrollArea>
    </motion.div>
  );
};
